var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { CustomSourceUploadResult } from "./../ComplianceUploads/CustomSourceUploadResult";
import { DataProcessingJob } from "./DataProcessingJob";
export class CustomSourceDataProcessingJob extends DataProcessingJob {
  constructor(_data) {
    super();
    /**
     */
    __publicField(this, "ConfigError");
    /**
     */
    __publicField(this, "Type");
    /**
     */
    __publicField(this, "ValidationResult");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof CustomSourceDataProcessingJob
     */
    __publicField(this, "$type", "V1.DataProcessingJobs.CustomSourceDataProcessingJob");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    super.init(_data);
    if (_data) {
      this.ConfigError = _data["ConfigError"];
      this.Type = CustomSourceDataProcessingJobType[_data["Type"]];
      if (_data["ValidationResult"]) {
        const validationResult_ = new CustomSourceUploadResult();
        this.ValidationResult = validationResult_.init(_data["ValidationResult"]);
      }
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    super.toJSON(_data);
    _data["ConfigError"] = this.ConfigError;
    _data["Type"] = CustomSourceDataProcessingJobType[this.Type];
    _data["ValidationResult"] = this.ValidationResult ? this.ValidationResult.toJSON() : void 0;
    return _data;
  }
}
export var CustomSourceDataProcessingJobType = /* @__PURE__ */ ((CustomSourceDataProcessingJobType2) => {
  CustomSourceDataProcessingJobType2["Sale"] = "Sale";
  CustomSourceDataProcessingJobType2["Purchase"] = "Purchase";
  CustomSourceDataProcessingJobType2["One"] = "One";
  return CustomSourceDataProcessingJobType2;
})(CustomSourceDataProcessingJobType || {});
